/* eslint quotes: 0 */
export default {
  "container": {
    "containerSearchInProgress": "Trwa wyszukiwanie kontenerów",
    "noContainersWithSufficientProductQuantityFound": "Nie znaleziono kontenerów z wystarczającą ilością wybranego produktu.",
    "searchForProductInContainers": "Szukaj produktu w kontenerach"
  },
  "contractor": {
    "acceptanceDate": "Data akceptacji",
    "all": "Wszystkie",
    "chooseContractor": "Wybierz wykonawcę",
    "chooseEndedStatus": "Pokazywać tylko zakończone?",
    "chooseSettlementStatus": "Wybierz status rozliczenia",
    "contractor": "Wykonawca",
    "dateOfSampleAndAcceptance": "Data próby i akceptacji",
    "listOfContractorsWorksToBeSettled": "Lista prac wykonawców do rozliczenia",
    "makeSettlementErrorText": "Rozliczenie nie powiodło się. Spróbuj ponownie.",
    "noItemsToBeSettled": "Brak elementów do rozliczenia",
    "onlyEnded": "Tylko zakończone",
    "serviceCost": "Koszt zdobienia",
    "toBeSettled": "Do rozliczenia",
    "unitPrice": "Cena jednostkowa"
  },
  "contractorsSettlementsImportPopup": {
    "importSuccessDesc": "Zaimportowano dane z pliku XLSX",
    "importSuccessTitle": "Dane zaimportowane",
    "importTitle": "Importuj listę prac wykonawców do rozliczenia",
    "importXlsx": "Importuj XLSX",
    "xlsxFile": "Plik XLSX"
  },
  "customer": {
    "addAddress": "Dodaj adres",
    "addAddressErrorText": "Dodawanie adresu nie powiodło się. Spróbuj ponownie.",
    "addAddressSuccessText": "Podany adres został zapisany",
    "addAddressSuccessTitle": "Dodano adres",
    "addContactPerson": "Dodaj osobę kontaktową",
    "addContactPersonErrorText": "Dodawanie osoby kontaktowej nie powiodło się. Spróbuj ponownie.",
    "addContactPersonSuccessText": "Podana osoba kontaktowa została zapisana",
    "addContactPersonSuccessTitle": "Dodano osobę kontaktową",
    "addCustomer": "Dodaj klienta",
    "addCustomerErrorText": "Dodawanie klienta nie powiodło się. Spróbuj ponownie.",
    "addCustomerSuccessText": "Podany klient został zapisany",
    "addCustomerSuccessTitle": "Dodano klienta",
    "addErrorText": "Nie udało się dodać klienta",
    "addNewCustomer": "Dodaj nowego klienta",
    "addSuccessText": "Na bazie podanych danych utworzono klienta",
    "addSuccessTitle": "Dodano klienta",
    "addingContactPersonAvailableAfterCustomerSave": "Dodawanie osób kontaktowych będzie możliwe po zapisaniu klienta.",
    "addingNewCustomer": "Dodawanie nowego klienta",
    "addingShippingAddressAvailableAfterCustomerSave": "Dodawanie adresów do wysyłki będzie możliwe po zapisaniu klienta.",
    "addingTransaltionsAvailableAfterCustomerSave": "Dodawanie tłumaczeń będzie możliwe po zapisaniu klienta.",
    "building": "Budynek",
    "buildingNumber": "Numer budynku",
    "changePassword": "Zmień hasło",
    "changeYourPassword": "Zmień swoje hasło",
    "city": "Miasto",
    "company": "Firma",
    "companyName": "Nazwa firmy",
    "contact": {
      "contact": "Kontakt"
    },
    "contactAddress": "Adres kontaktowy",
    "contactPeople": "Osoby kontaktowe",
    "correspondenceAddressSet": "Zmieniono dane",
    "correspondenceAddressSetDesc": "Ustawiono adres korespondencyjny",
    "correspondenceInfo": "Dane korespondencyjne",
    "customerCountryQuestionMark": "Kraj klienta?",
    "customerLogo": "Logo klienta",
    "customers": "Klienci",
    "customersList": "Lista klientów",
    "deleteAddressConfirmTitle": "Czy na pewno chcesz usunąć ten adres?",
    "deleteAddressErrorText": "Usuwanie adresu nie powiodło się. Spróbuj ponownie.",
    "deleteAddressSuccessText": "Wybrany adres został usunięty",
    "deleteAddressSuccessTitle": "Usunięto adres",
    "deleteContactPersonConfirmTitle": "Czy na pewno chcesz usunąć tę osobę kontaktową?",
    "deleteContactPersonErrorText": "Usuwanie osoby kontaktowej nie powiodło się. Spróbuj ponownie.",
    "deleteContactPersonSuccessText": "Wybrana osoba kontaktowa została usunięta",
    "deleteContactPersonSuccessTitle": "Usunięto osobę kontaktową",
    "discount": {
      "deliveryDiscount": "Rabat na dostawę",
      "productDiscount": "Rabat na produkty",
      "servicesDiscount": "Rabat na zdobienia"
    },
    "edit": "Edycja klienta",
    "editAddress": "Edytuj adres",
    "editAddressErrorText": "Edycja adresu nie powiodła się. Spróbuj ponownie.",
    "editAddressSuccessText": "Podany adres został zmieniony",
    "editAddressSuccessTitle": "Zmieniono adres",
    "editClientErrorText": "Edycja klienta nie powiodła się. Spróbuj ponownie.",
    "editClientSuccessText": "Dane klienta zostały zmodyfikowane",
    "editClientSuccessTitle": "Zmodyfikowano klienta",
    "editContactPerson": "Edytuj osobę kontaktową",
    "editContactPersonErrorText": "Edycja osoby kontaktowej nie powiodła się. Spróbuj ponownie.",
    "editContactPersonSuccessText": "Podana osoba kontaktowa została zmieniona",
    "editContactPersonSuccessTitle": "Zmieniono osobę kontaktową",
    "editPasswordErrorText": "Zmiana hasła nie powiodła się. Spróbuj ponownie.",
    "editPasswordSuccessText": "Hasło zostało zmienione",
    "editPasswordSuccessTitle": "Zmieniono hasło",
    "enterCustomerData": "Podaj dane klienta",
    "fountAddresses": "Znalezionych adresów:",
    "getDataFromGUS": "Pobierz dane z GUS",
    "getDataFromVIES": "Pobierz dane z VIES",
    "houseNumber": "Numer lokalu",
    "invoiceAddressSet": "Zmieniono dane",
    "invoiceAddressSetDesc": "Ustawiono dane do faktury",
    "invoiceAndCorrespondenceAddressSet": "Zmieniono dane",
    "invoiceAndCorrespondenceAddressSetDesc": "Ustawiono dane do faktury i dane korespondencyjne",
    "invoiceInfo": "Dane do faktury",
    "invoiceName": "Nazwa na fakturze",
    "isOrdersInRpogress": "Zamówienia w toku?",
    "maxAddressSearchResults": "Maksymalnie wyświetlanych jest 50 pasujących adresów, jeśli nie możesz znaleźć potrzebnego adresu - zawęź kryteria wyszukiwania.",
    "newsletterAgreement": "Zgoda na newsletter",
    "noAddressesToDisplay": "Brak adresów do wyświetlenia",
    "noContactPeopleToDisplay": "Brak osób kontaktowych do wyświetlenia",
    "noCustomerMarchingPhraseFound": "Brak klientów pasujących do podanej frazy",
    "noCustomersToDisplay": "Brak klientów do wyświetlenia",
    "noTranslationsForThisClient": "Brak tłumaczeń dla tego klienta",
    "notFoundInVIESGUSText": "Nie znaleziono podanej firmy w bazie",
    "notFoundInVIESGUSTitle": "Nie znaleziono",
    "offersInProgress": "Ofert w toku",
    "ordersAndOffers": "Zamówień i ofert",
    "ordersInProgress": "Zamówień w toku",
    "passowrdChange": "Zmiana hasła",
    "person": "Osoba",
    "phoneShortCap": "Tel",
    "profile": "Profil",
    "removeCustomerConfirmTitle": "Czy na pewno chcesz usunąć tego klienta?",
    "removeCustomerErrorText": "Usuwanie klienta nie powiodło się. Spróbuj ponownie.",
    "removeCustomerSuccessText": "Wybrany klient został usunięty",
    "removeCustomerSuccessTitle": "Usunięto klienta",
    "removeLogo": "Usuń logo",
    "searchAddressesByCompanyNameAddressOrContactInfo": "Wyszukaj adresy po nazwie firmy, adresie lub danych kontaktowych",
    "selectCustomer": "Wybierz klienta",
    "shippingInfo": "Dane do wysyłki",
    "showCustomerDrafts": "Pokaż oferty",
    "showCustomerOrders": "Pokaż zamówienia",
    "statistics": "Statystyki",
    "stockReportsNotifications": "Powiadomienia o stockach",
    "street": "Ulica",
    "telephone": "Telefon",
    "termsOfSale": "Warunki sprzedaży",
    "unsettledInvoices": "Nierozliczonych faktur",
    "vatIDNumber": "NIP / VAT ID",
    "verificationIntegrationDisabledDesc": "Usługa pobierania danych jest obecnie niedostępna",
    "verificationIntegrationDisabledTitle": "Usługa niedostępna",
    "withOrdersInProgress": "Z zamówieniami w toku",
    "withoutOrdersInProgress": "Bez zamówień w toku",
    "youMustSelectCountryPrefix": "Wybierz kod kraju",
    "youMustSelectCountryPrefixDesc": "Aby pobrać dane, należy podać kod kraju",
    "yourAccount": "Twoje konto",
    "zipCode": "Kod pocztowy"
  },
  "customerOrdersPopup": {
    "offers": "Oferty klienta",
    "orders": "Zamówienia klienta"
  },
  "dashboard": {
    "customersPopup": {
      "customerEmail": "E-mail",
      "customerName": "Nazwa klienta",
      "customerPhone": "Telefon",
      "title": "Wyślij zapytania do klientów"
    }
  },
  "errorPage": {
    "errorCode": "404",
    "pageDoesNotExist": "Wybrana podstrona nie istnieje",
    "tryAgainLaterOrContactAdministrator": "Spróbuj ponownie później lub skontaktuj się z administratorem systemu."
  },
  "inquiries": {
    "addComments": "Dodaj swoje uwagi",
    "addFirstProductInstructionInfo": "Dodaj swój pierwszy produkt klikając \"+ Produkt\"",
    "addFirstServiceInstructionInfo": "Dodaj swoje pierwsze zdobienie ogólne klikając \"+ Zdobienie ogólne\"",
    "caanotCreateOrder": "Nie można utworzyć zamówienia",
    "executionTime": "Czas realizacji",
    "failedToAddProductsToOrder": "Nie dodano produktów do zamówienia",
    "globalServicesTooltip": "Jeśli wiele produktów będzie posiadało takie same zdobienie, dodaj zdobienie ogólne z tego miejsca. Wówczas policzymy tylko raz koszt setupu. Liczbę zamówionych zdobień będziesz mógł rozdzielić na pojedyczne produkty.",
    "needExecutionTill": "Potrzebuję realizacji do dnia",
    "noComments": "Brak uwag",
    "noDateSelected": "Brak terminu",
    "orderAdditionalInfo": "Dodatkowe uwagi do zamówienia",
    "selectExecutionTime": "Wybierz czas realizacji",
    "trackingNumber": "Numer trackingowy",
    "unexpectedErrorOccured": "Wystąpił nieoczekiwany problem"
  },
  "login": {
    "authError": "Błąd autoryzacji. Spróbuj ponownie",
    "emailPlaceholder": "Twój adres e-mail",
    "loginInProgress": "Logowanie...",
    "loginLabel": "Zaloguj",
    "password": "Hasło",
    "passwordPlaceholder": "********",
    "register": "Nie masz konta?",
    "resetPassword": "Zapomniałeś hasła?"
  },
  "noPermissions": {
    "noPermissionsDescription": "Jeżeli uważasz, że to błąd - skontaktuj się z administratorem systemu.",
    "noPermissionsText": "Nie masz uprawnień do przeglądania tej strony",
    "noPermissionsTitle": "Brak uprawnień"
  },
  "order": {
    "addNewDraft": "Dodaj nową ofertę",
    "addNewFemenine": "Dodaj nową",
    "addNewOrder": "Dodaj nowe zamówienie",
    "addNewShippingAddress": "Dodaj nowy adres wysyłki",
    "addedProducts": "Dodano następujące produkty:",
    "addressRemoved": "Poprzednio używany adres został usunięty. Proszę wybrać nowy adres.",
    "awaitingInvoice": "czekających na wystawienie faktury",
    "awaitingProductionComplete": "czekających na zakończenie produkcji",
    "awaitingSample": "czekających na próbę",
    "awaitingSampleAcceptance": "czekających na akceptację próby",
    "beeingCollected": "W trakcie zbierania",
    "blockade": "Blokada",
    "cartonsMissingInfo": "Liczba kartonów może wymagać korekty, ponieważ niektóre produkty nie mają określonej liczby sztuk w kartonach.",
    "cartonsNumber": "Liczba kartonów",
    "checkFormDesc": "Podczas walidacji zostały znalezione błędy wymagające poprawienia. Proszę sprawdzić zakładki formularza i poprawić znalezione błędy.",
    "checkFormTitle": "Proszę sprawdzić formularz",
    "chooseShippingAddress": "Wybierz adres wysyłki",
    "clientContactPerson": "Osoba kontaktowa klienta",
    "connectedInvoices": "Powiązane faktury",
    "currentDiscountOfCustomer": "Zapisany w profilu rabat klienta to",
    "customerAndName": "Klient i nazwa",
    "customerDiscounts": "Rabaty klienta",
    "dashOrderAwaitingShipping": "- zamówienia oczekujące wysyłki",
    "dashReadyForShipping": "- gotowe do wysyłki",
    "dateOfIssue": "Data wystawienia",
    "deleted": "Usunięte",
    "delivery": "Dostawa",
    "download": "Pobierz",
    "downloadPDF": "Pobierz PDF",
    "downloadPDFforMe": "Oferta dla mojej FIRMY",
    "downloadPDFforMyCustomer": "Oferta dla mojego KLIENTA",
    "downloadXls": "Pobierz XLS",
    "draftDeleteConfirmTitle": "Czy na pewno chcesz usunąć tę ofertę?",
    "draftDeleteErrorText": "Usuwanie oferty nie powiodło się. Spróbuj ponownie.",
    "draftDeleteSuccessText": "Wybrana oferta została usunięta",
    "draftDeleteSuccessTitle": "Usunięto ofertę",
    "draftsList": "Lista ofert",
    "duplicateOrder": {
      "questionTextOffer": "Czy na pewno chcesz zduplikować wybraną ofertę?",
      "questionTextOrder": "Czy na pewno chcesz zduplikować wybrane zamówienie?",
      "questionTitle": "Potwierdź operację",
      "successTextOffer": "Wybrana oferta została pomyślnie zduplikowana",
      "successTextOrder": "Wybrane zamówienie zostało pomyślnie zduplikowane",
      "successTitleOffer": "Zduplikowano ofertę",
      "successTitleOrder": "Zduplikowano zamówienie"
    },
    "editDraft": "Edytuj ofertę",
    "editDraftErrorText": "Nie udało się zapisać oferty",
    "editDraftSaveSuccessText": "Oferta została pomyślnie zapisana",
    "editDraftSuccessTitle": "Zapisano ofertę",
    "editingOfferFromHPL1": "Edytujesz ofertę utworzoną dla <strong>Twojej FIRMY</strong>. Jeśli chcesz przekształcić ją w <strong>ofertę dla Twojego KLIENTA</strong> kliknij ",
    "editingOfferFromHPL2": "tutaj",
    "editingOfferFromHPL3": "Pamiętaj aby zapisać ofertę po tej zmianie.",
    "ended": "Zakończone",
    "errors": {
      "shipping_price_not_fetched": "Nie udało się zaktualizować ceny dostawy. Zweryfikuj cenę dostawy."
    },
    "fileSuffixOfferCustomer": "-OFERTA-KLIENT",
    "fileSuffixOfferMe": "-OFERTA-HPL",
    "files": {
      "addingFile": "Dodawanie pliku",
      "deleteFile": "Usuń plik",
      "editFile": "Edytuj plik",
      "editFileText": "Podaj zaktualizowany opis pliku",
      "editFileTitle": "Zmiana opisu pliku",
      "fileEditError": "Wystapił błąd podczas edycji pliku. Spróbuj ponownie.",
      "noFilesToDisplay": "Brak plików powiązanych z tym zamówieniem",
      "noServiceFilesToDisplay": "Brak plików powiązanych z tym zdobieniem",
      "removeFileDesc": "Tej operacji nie można cofnąć",
      "removeFileTitle": "Czy na pewno chcesz usunąć ten plik?",
      "title": "Pliki przypisane do zamówienia",
      "uploadError": "Wystąpił błąd podczas dodawania pliku"
    },
    "forAcceptance": "Do akceptacji",
    "inProduction": "W produkcji",
    "includedCustomerDiscount": "Rabat klienta",
    "includedMarkup": "Narzut",
    "invoicesIssued": "Wystawionych faktur",
    "lastChange": "ost. zmiana",
    "lastItemModified": "Ostatnio zmieniane",
    "lastItemViewed": "Ostatnio oglądane",
    "nameCheck": {
      "inProgress": "Sprawdzam nazwę zamówienia",
      "inUse": "Wybrana nazwa zamówienia jest już w użyciu przez inne zamówienia.",
      "isAvailable": "Wybrana nazwa zamówienia jest dostępna"
    },
    "noAddressFound": "Brak wybranego adresu",
    "noAddresses": "Brak adresów",
    "noAddressesForThisClient": "Brak adresów przypisanych do klienta.",
    "noContactPeople": "Brak osób kontaktowych",
    "noInvoicesConnectedToOrder": "Brak faktur powiązanych z tym zamówieniem",
    "nonExistingCustomerText": "Klient, który był przypisany do tego zamówienia, został usunięty. Należy na nowo ustawić klienta w zamówieniu.",
    "nonExistingCustomerTitle": "Wybrany klient nie istnieje",
    "noOffersOrOrdersToDisplay": "Brak ofert i zamówień do wyświetlenia",
    "noOrderMatchingPhraseFound": "Brak zamówień pasujących do podanej frazy",
    "noTagsMatchingGivenPhrase": "Brak cech pasujących do podanej frazy",
    "number": "Numer",
    "numberOfOrderdProducts": "Liczba zamawianych produktów",
    "offerCurrency": "Waluta oferty",
    "offerLanguage": "Język oferty",
    "offerPreparedFor": "Oferta przygotowana dla",
    "offerSubmissionDate": "Data złożenia oferty",
    "offersToCheck": "Oferty do sprawdzenia",
    "orderNumber": "Numer zamówienia",
    "orderPreparedFor": "Zamówienie przygotowane dla",
    "orderPreview": "Podgląd zamówienia",
    "orders": "Zamówienia",
    "ordersList": "Lista zamówień",
    "ordersXlsFilename": "lista-zamowien",
    "paymentDate": "Data płatności",
    "paymentDeadline": "Termin płatności",
    "pdfDownloadNoticeDesc": "Pobierasz ofertę PDF dla siebie. Nie przekazuj tego pliku swojemu klientowi.",
    "pdfDownloadNoticeTitle": "Uwaga!",
    "pendingPayment": "Oczekuje na płatność",
    "priceChangePopup": {
      "changeSource": "Źródło zmiany",
      "element": "Element",
      "new": "Nowa wartość",
      "previous": "Poprzednia wartość",
      "sources": {
        "prices": "Cennik HPL",
        "customer_prices": "Twój cennik"
      },
      "subtitle": "Zmiany te zostaną uwzględnione po ponownym zapisaniu oferty",
      "title": "Wprowadzono następujące zmiany cen",
      "type": "Rodzaj zmiany",
      "types": {
        "globalServiceMultipleFrom": "Mnożnik globalnego zdobienia",
        "globalServicePrice": "Cena globalnego zdobienia",
        "globalServiceSetupPrice": "Cena setup globalnego zdobienia",
        "product": "Produkt",
        "serviceMultipleFrom": "Mnożnik zdobienia",
        "servicePrice": "Cena zdobienia",
        "serviceSetupPrice": "Cena setup zdobienia"
      }
    },
    "productMinQty": "Min. ilość",
    "productsTags": "Cechy produktów",
    "readyForShipping": "Gotowe do wysyłki",
    "saveAsOrder": "Przekaż zamówienie do realizacji",
    "saveAsOrderNoticeDesc": "Po zapisaniu jako zamówienie, nie można edytować danych - upewnij się, że wszystkie wprowadzone dane są poprawne.",
    "saveAsOrderNoticeTitle": "Przekaż zamówienie do realizacji",
    "saveDraft": "Zapisz ofertę",
    "see": "Zobacz",
    "selectOrder": "Wybierz zamówienie",
    "sent": "Wysłane",
    "servicesGenitive": "Zdobień",
    "shippingAddress": "Adres wysyłki",
    "showAddress": "Pokaż adres",
    "showContact": "Pokaż kontakt",
    "summary": "Podsumowanie",
    "toCheckInWarehouse": "Do sprawdzenia w magazynie",
    "toCollect": "Do zebrania",
    "toDelete": "Do usunięcia",
    "totalCost": "Koszt całkowity",
    "totalDeliveryCostNet": "Koszt dostawy (netto)",
    "useCustomerDiscounts": "Korzystaj z rabatów klienta",
    "usePartnerPricing": "Użyj swojego cennika w tym zamówieniu",
    "valueForPartnerCustomer": "Wartość zamówienia dla klienta",
    "waitingForShipping": "Czeka na wysyłkę",
    "waitingPurchaseProducts": "Oczekuje na produkty",
    "whoOrders": "Zamawiający",
    "whoOrdersMe": "Mojej FIRMY",
    "whoOrdersMyCustomer": "Mojego KLIENTA",
    "withDeadlineApproaching": "którym zbliża się deadline",
    "yesSave": "Tak, zapisz",
    "yourDiscounts": "Twoje rabaty",
    "yourPrice": "Twoja cena"
  },
  "price": {
    "addNewPrice": "Dodaj nową cenę",
    "addNewProductPrice": "Dodaj nową cenę produktu",
    "addNewServicePrice": "Dodaj nową cenę zdobienia",
    "addNewSetupPrice": "Dodaj nową cenę setup",
    "addPrice": "Dodaj cenę",
    "addPriceErrorText": "Dodawanie ceny nie powiodło się. Spróbuj ponownie.",
    "addPriceSuccessText": "Podana cena została zapisana",
    "addPriceSuccessTitle": "Dodano cenę",
    "bruttonPrice": "Cena brutto",
    "chosenPriceIsSetupPrice": "Podana cena jest ceną za setup",
    "deletePriceConfirmTitle": "Czy na pewno chcesz usunąć tę cenę?",
    "deletePriceErrorText": "Usuwanie ceny nie powiodło się. Spróbuj ponownie.",
    "deletePriceSuccessText": "Wybrana cena została usunięta",
    "deletePriceSuccessTitle": "Usunięto cenę",
    "differentPriceMultipleFromInfo": "Zastosowany mnożnik ceny \"za sztukę od\" różni się od aktualnego mnożnika ceny ({value} szt.)",
    "editPrice": "Edytuj cenę",
    "export": "Eksportuj",
    "exportPrices": "Eksportuj cenniki",
    "exportSuccessfull": "Wyeksportowano cenniki",
    "exportSuccessfullDesc": "Pomyślnie wyeksportowano cenniki",
    "importPrices": "Importuj cenniki",
    "importSuccessfull": "Zaimportowano cenniki",
    "importSuccessfullDesc": "Pomyślnie zaimportowano cenniki",
    "includeSetupPrices": "Uwzględniaj ceny setup",
    "isSale": "Wyprzedaż",
    "noPricesFoundForServiceGroup": "Nie znaleziono cenników dla wybranej grupy zdobień",
    "noPricesToDisplay": "Brak cen do wyświetlenia",
    "onlyPriceUpdate": "Tylko aktualizacja cen",
    "pln": "PLN",
    "plnBrutto": "PLN brutto",
    "plnNet": "PLN netto",
    "plnVat": "PLN VAT",
    "price": "Cena",
    "priceFlat": "Płaska stawka",
    "priceBox": "Stawka od ilości",
    "price25pcs": "do 25 szt.",
    "priceFirstBox": "Pierwszy karton",
    "priceSecondBox": "Drugi karton",
    "priceNextBox": "Kolejny karton",
    "priceBeforeDicount": "Cena przed rabatem",
    "priceEdit": "Edycja ceny",
    "priceFrom": "Cena od",
    "priceImportFrom": "Import cen z",
    "priceNet": "Cena netto",
    "pricePerItem": "Cena za sztukę",
    "pricePerItemFrom": "Cena za sztukę od {price} szt.",
    "pricePerItemShort": "Cena za szt.",
    "prices": "Ceny",
    "priceTo": "Cena do",
    "pricesLists": "Cenniki",
    "pricesListsLowCase": "cenniki",
    "productGenitive": "produktu",
    "productsPricesList": "Lista cen produktów",
    "quantityFrom": "Ilość od",
    "quantityTo": "Ilość do",
    "removeAndReplacePrices": "Usuń ceny i dodaj na nowo",
    "savePriceErrorText": "Edycja ceny nie powiodła się. Spróbuj ponownie.",
    "savePriceSuccessText": "Wybrana cena została zmieniona",
    "savePriceSuccessTitle": "Zmieniono cenę",
    "seePricelist": "Zobacz cennik",
    "serviceGenitive": "zdobienia",
    "servicesPriceList": "Cennik zdobień",
    "servicesPricesList": "Lista cen zdobień",
    "setup": "setup",
    "setupPricesList": "Lista cen setup",
    "supplierPricesFileNamePrefix": "cenniki-dostawcy-",
    "unitPricesIn": "ceny za sztukę w",
    "vat": "VAT",
    "vatRate": "Stawka VAT",
    "xlsxFileWithPrices": "Plik XLSX z cenami"
  },
  "product": {
    "addGlobalService": "Zdobienie ogólne",
    "addGlobalServicesPackage": "Pakiet zdobień",
    "addProduct": "Produkt",
    "breakProductsIntoSeparateOffers": "Rozbij produkty na osobne oferty",
    "checkAvailability": "Sprawdź najbliższe dostawy",
    "enterAdditionalProductDescriptionOptional": "Wprowadź dodatkowy opis produktu (opcjonalne)",
    "enterProductNameOrCode": "Podaj nazwę lub kod produktu",
    "globalServices": "Zdobienia ogólne",
    "noProductsMatchingGivenPhrase": "Brak produktów pasujących do podanej frazy",
    "notIncludedInDiscounts": "Nie podlega rabatom",
    "product": "Produkt",
    "productCode": "Kod produktu",
    "productName": "Nazwa produktu",
    "products": "Produkty",
    "productsCodes": "Kody produktów",
    "selectProduct": "Wybierz produkt",
    "totalBeforeDiscount": "Przed rabatem",
    "totalMarkup": "W tym narzut",
    "totalProductsCostNet": "Koszt produktów (netto)",
    "totalServicesCostNet": "Koszt zdobień (netto)",
    "useCustomPartnerPrice": "Użyj własnej ceny",
    "useDefaultPartnerPrice": "Użyj domyślnej ceny"
  },
  "purchase": {
    "addOrderErrorText": "Dodawanie zamówienia nie powiodło się. Spróbuj ponownie.",
    "editOrderSuccessTitle": "Zapisano zamówienie",
    "fileDeletedDesc": "Wybrany plik został usunięty",
    "fileDeletedTitle": "Plik usunięto",
    "numberOfPiecesNeeded": "Liczba potrzebnych sztuk",
    "removeFileInProgress": "Usuwanie pliku",
    "yourOrderSaveSuccessText": "Twoje zamówienie zostało zapisane"
  },
  "register": {
    "customerTaxNumber": "NIP/VAT ID",
    "login": "Zaloguj się",
    "password": "Hasło",
    "passwordConfirmation": "Powtórz hasło",
    "passwordReset": {
      "error": "Zmiana hasła nie powiodła się",
      "resetLabel": "Zmień hasło",
      "resetInProgress": "Zapisywanie zmian",
      "success": "Zmieniono hasło - możesz się zalogować",
      "title": "Zmień hasło"
    },
    "passwordResetRequest": {
      "error": "Resetowanie hasła nie powiodło się",
      "resetInProgress": "Resetowanie hasła",
      "resetLabel": "Poproś o reset hasła",
      "success": "Przesłano żądanie resetu hasła. Jeżeli podany mail istnieje w systemie, otrzymasz dalsze instrukcje na podaną skrzynkę.",
      "title": "Zresetuj hasło"
    },
    "registerError": "Rejestracja nie powiodła się",
    "registerInProgress": "Rejestracja w toku",
    "registerLabel": "Zarejestruj się",
    "registerSuccess": "Konto utworzone. Oczekuje na weryfikację i zatwierdzenie.",
    "title": "Utwórz konto"
  },
  "service": {
    "addService": "Zdobienie",
    "addServicesPackage": "Pakiet zdobień",
    "addServicesPackageBtn": "Dodaj pakiet zdobień",
    "chooseEmbroideryPosition": "Wybierz pozycję zdobienia",
    "chooseEmbroideryType": "Wybierz rodzaj zdobienia",
    "chooseService": "Wybierz zdobienie",
    "chooseServiceGroup": "Wybierz grupę zdobień",
    "commonServices": "Zdobienia wspólne",
    "complexity": "Poziom skomplikowania",
    "descriptionFoCustomer": "Opis dla klienta",
    "detailsOfServiceInOrder": "Szczegóły dot. zdobień w zamówieniu",
    "downloadLogo": "Pobierz logo",
    "dstNumber": "Numer DST",
    "embroidery": {
      "colors": "Kolory zdobienia",
      "height": "WYS",
      "position": "Pozycja zdobienia",
      "size": "Rozmiar zdobienia (mm)",
      "type": "Rodzaj zdobienia",
      "width": "SZER"
    },
    "enterServiceNameOrCode": "Podaj nazwę lub kod zdobienia",
    "files": {
      "title": "Pliki zdobienia"
    },
    "findService": "Znajdź pasujące zdobienie",
    "noServiceGroupsMatchingPhrase": "Brak grup zdobień pasujących do podanej frazy",
    "noServicesMatchingPhrase": "Brak zdobień pasujących do podanej frazy",
    "productionCompleteDate": "Data zakończenia produkcji",
    "sample": {
      "sampleAcceptDate": "Data zaakceptowania próby",
      "sampleDate": "Data próby",
      "samplePhotosDateCreated": "Data dodania",
      "samplePhotosDownload": "Pobierz",
      "samplePhotosDownloadAll": "Pobierz wszystkie",
      "samplePhotosSeePreview": "Zobacz zdjęcie próby",
      "samplePhotosTitle": "Zdjęcia prób",
      "sampleReceiveDate": "Data otrzymania próby"
    },
    "sampleFiles": {
      "title": "Pliki próby"
    },
    "samples": {
      "noSamples": "Brak prób",
      "rejectReason": "Powód odrzucenia",
      "sample": "Próba",
      "saveBeforeAddingFiles": "Zapisz zamówienie aby móc dodawać pliki",
      "statuses": {
        "accepted": "Zaakceptowano",
        "rejected": "Odrzucono"
      },
      "title": "Próby zdobienia"
    },
    "selectFileWithLogo": "Wybierz plik z logo",
    "selectService": "Wybierz zdobienie",
    "selectedServiceName": "Wybrane zdobienie",
    "service": "Zdobienie",
    "serviceCode": "Kod zdobienia",
    "serviceGroup": "Grupa zdobienia",
    "serviceName": "Nazwa zdobienia",
    "serviceNotFound": "Nie znaleziono zdobienia",
    "serviceNotFoundDesc": "Dla podanej grupy zdobień, złożoności zdobienia i podanych wymiarów nie znaleziono pasujących zdobień. Spróbuj innej konfiguracji zdobienia.",
    "servicesPackage": {
      "dates": {
        "date": "Termin",
        "types": {
          "obtaining_at": "Data otrzymania próby",
          "accepted_at": "Data zaakceptowania próby",
          "sample_hpl_accepted_at": "Data akceptacji próby"
        }
      }
    },
    "servicesPackageHideContents": "Ukryj zawartość",
    "servicesPackageInvalidConfig": {
      "noMatchingService": "Brak pasującego zdobienia dla podanej konfiguracji",
      "wrongDimensions": "Podano nieprawidłowe wymiary zdobienia"
    },
    "servicesPackageModify": "Modyfikuj rozmiar i stopień skomplikowania zdobienia",
    "servicesPackageVariant": "Dobrany wariant",
    "servicesPackageName": "Nazwa pakietu zdobień",
    "servicesPackagePopup": {
      "addServicesPackage": "Dodaj pakiet zdobień",
      "includedServices": "Zdobienia wchodzące w skład wybranego pakietu zdobień:",
      "noServicesIncluded": "Brak zdobień przypisanych do wybranego pakietu zdobień.",
      "noServicesPackagesMatchingGivenPhrase": "Brak pakietów pasujących do podanej frazy",
      "selectServicesPackage": "Wybierz pakiet zdobień",
      "title": "Wybierz pakiet zdobień do dodania"
    },
    "servicesPackageShowContents": "Pokaż zawartość",
    "setupPrice": "Koszt Setup",
    "stitchNumber": "Liczba ściegów",
    "strandColors": "Kolory nici",
    "wrongDimensions": "Błędne wymiary zdobienia",
    "wrongDimensionsDesc": "Należy podać szerokość i wysokość zdobienia"
  },
  "settings": {
    "country": {
      "country": "Kraj",
      "countryCode": "Kod kraju",
      "selectCountry": "Wybierz kraj"
    },
    "currency": {
      "chooseCurrency": "Wybierz walutę",
      "currency": "Waluta",
      "noCurrenciesAvailable": "Brak dostępnych walut..."
    },
    "language": {
      "chooseLanguage": "Wybierz język",
      "noLanguagesAvailable": "Brak dostępnych języków"
    },
    "transaltion": {
      "addTranslation": "Dodaj tłumaczenie",
      "addTranslationErrorText": "Dodawanie tłumaczenia nie powiodło się. Spróbuj ponownie.",
      "addTranslationSuccessText": "Podane tłumaczenie zostało zapisane",
      "addTranslationSuccessTitle": "Dodano tłumaczenie",
      "deleteTranslationConfirmTitle": "Czy na pewno chcesz usunąć to tłumaczenie?",
      "deleteTranslationErrorText": "Usuwanie tłumaczenia nie powiodło się. Spróbuj ponownie.",
      "deleteTranslationSuccessText": "Wybrane tłumaczenie zostało usunięte",
      "deleteTranslationSuccessTitle": "Usunięto tłumaczenie",
      "editTranslation": "Edytuj tłumaczenie",
      "translationEditErrorText": "Edycja tłumaczenia nie powiodła się. Spróbuj ponownie.",
      "translationEditSuccessText": "Wybrane tłumaczenie zostało zmienione",
      "translationEditSuccessTitle": "Zmodyfikowano tłumaczenie",
      "translations": "Tłumaczenia"
    }
  },
  "settlements": {
    "amount": "Kwota",
    "deadlines": "Terminy",
    "invoiceList": "Lista faktur",
    "issued": "Wystawiono",
    "noSettlementsToDisplay": "Brak rozliczeń do wyświetlenia",
    "paymentDueDate": "Płatność do",
    "settle": "Rozlicz",
    "settled": "Rozliczono",
    "settlement": "Rozliczenie",
    "settlements": "Rozliczenia",
    "type": "Rodzaj"
  },
  "shippers": {
    "chooseShipper": "Wybierz spedytora",
    "noShippersAvailable": "Brak dostępnych spedytorów"
  },
  "status": {
    "status": "Status",
    "statusQuestionMark": "Status?"
  },
  "translation": {
    "editTranslation": "Edytuj tłumaczenie",
    "languageLocative": "języku",
    "languagesLocative": "językach",
    "missingTranslationsIn": "Brak tłumaczenia w ",
    "noTranslationsToDisplay": "Brak dostępnych tłumaczeń...",
    "systemName": "Nazwa systemowa",
    "translated": "Przetłumaczone",
    "translationEditErrorText": "Wystąpił błąd podczas zapisu zmian. Spróbuj ponownie...",
    "translationEditSuccessText": "Zapisano zmiany tłumaczeń",
    "translationEditSuccessTitle": "Zapisano zmiany",
    "translationStatus": "Status tłumaczenia",
    "translations": "Tłumaczenia",
    "translationsTitle": "Lista tłumaczeń",
    "valueInPolish": "Po polsku"
  },
  "ui": {
    "actionFailedTryAgain": "Operacja nie powiodła się. Spróbuj ponownie.",
    "actions": "Akcje",
    "add": "Dodaj",
    "addDescription": "Dodaj opis",
    "addNew": "Dodaj nowy",
    "addToCart": "Do koszyka",
    "address": "Adres",
    "allFieldsAreRequired": "Należy wypełnić wszystkie pola",
    "amount": "Ilość",
    "availability": "Dostępność",
    "back": "Wróć",
    "backToList": "Wróć do listy",
    "cancel": "Anuluj",
    "cart": "Koszyk",
    "cartIsEmpty": "Koszyk jest pusty",
    "chooseDate": "Wybierz datę",
    "close": "Zamknij",
    "companyName": "Nazwa firmy",
    "contactPerson": "Osoba kontaktowa",
    "createOrderFromCart": "Utwórz zamówienie z produktów",
    "dataLoading": "Trwa ładowanie danych",
    "dataLoadingFailed": "Wczytywanie danych nie powiodło się.",
    "daysOfWeek": {
      "fri": "Ptk",
      "mon": "Pon",
      "sat": "Sob",
      "sun": "Ndz",
      "thur": "Czw",
      "tue": "Wto",
      "wed": "Śro"
    },
    "deadlinePreferred": "Preferowany termin",
    "delete": "Usuń",
    "deleteConfirmText": "Tej operacji nie można cofnąć",
    "downloadInProgress": "Trwa pobieranie",
    "duplicate": "Duplikuj",
    "eMailCap": "E-mail",
    "eMailShort": "e-mail",
    "edit": "Edytuj",
    "emailAddress": "Adres e-mail",
    "errorOccured": "Wystąpił błąd",
    "errorOccuredDuringDownload": "Wystąpił błąd podczas pobierania",
    "filtersSearch": "Szukaj",
    "generalInfo": "Dane ogólne",
    "importErrorTitle": "Wystąpił błąd podczas importu",
    "importFile": "Importuj plik",
    "importType": "Typ importu",
    "inCart": "W koszyku",
    "invoiceNumber": "Numer faktury",
    "isSettled": "Rozliczone?",
    "lack": "Brak",
    "language": "Język",
    "leadingPerson": "Prowadzący zamówienie",
    "loadError": "WYSTAPIŁ BŁAD WCZYTYWANIA",
    "markupProducts": "Narzut na produktach",
    "markupServices": "Narzut na zdobieniach",
    "markupSetupServices": "Narzut na setup zdobień",
    "markupShipping": "Narzut na dostawie",
    "monthNames": {
      "apr": "Kwi",
      "aug": "Sie",
      "dec": "Gru",
      "feb": "Lut",
      "jan": "Sty",
      "jul": "Lip",
      "jun": "Cze",
      "mar": "Mar",
      "may": "Maj",
      "nov": "Lis",
      "oct": "Paź",
      "sep": "Wrz"
    },
    "myOrders": "Moje zamówienia",
    "name": "Nazwa",
    "nameAndSurename": "Imię i nazwisko",
    "no": "Nie",
    "noAvailabilityData": "Brak danych o dostępności",
    "notSettled": "Nierozliczone",
    "ok": "OK",
    "okUnderstand": "OK, rozumiem",
    "order": "Zamówienie",
    "orderName": "Nazwa zamówienia",
    "pagination": {
      "itemsAmount": "Ilość pozycji:"
    },
    "partnerDiscountProducts": "Rabat klienta na produkty",
    "partnerDiscountServices": "Rabat klienta na zdobienia",
    "partnerDiscountShipping": "Rabat klienta na dostawę",
    "phoneShort": "tel.",
    "pieces": "Sztuk",
    "piecesAbbr": "szt.",
    "piecesAmount": "Ilość sztuk",
    "productsGenitive": "Produktów",
    "refNumber": "Numer referencyjny",
    "refreshPage": "Odśwież stronę",
    "repeatPassword": "Powtórz hasło",
    "resetFilters": "Resetuj filtry",
    "saveChanges": "Zapisz zmiany",
    "search": "Szukaj",
    "searchFrom": " szukaj od ",
    "searchTo": " do ",
    "searching": "Trwa wyszukiwanie",
    "selectContactPerson": "Wybierz osobę kontaktową",
    "selectFile": "Wybierz plik",
    "selectLeadingPerson": "Wybierz osobę prowadzącą zamówienie",
    "selectedPersonNotFound": "Brak wybranej osoby",
    "settled": "Rozliczone",
    "shipper": "Spedytor",
    "supplier": "Dostawca",
    "toTryAgain": "aby spróbować ponownie.",
    "tryAgain": "Spróbuj ponownie",
    "value": "Wartość",
    "viewInNewTab": "Zobacz w nowej zakładce",
    "yes": "Tak",
    "yesRemove": "Tak, usuń"
  },
  "users": {
    "accountActive": "Konto aktywne",
    "accountInactive": "Konto nieaktywne",
    "active": "Aktywne",
    "addUser": "Dodaj użytkownika",
    "addUserErrorText": "Dodawanie użytkownika nie powiodło się. Spróbuj ponownie.",
    "addUserSuccessText": "Podany użytkownik został zapisany",
    "addUserSuccessTitle": "Dodano użytkownika",
    "addingNewUser": "Dodawanie nowego użytkownika",
    "customer": "Klient",
    "deleteConfirmTitle": "Czy na pewno chcesz usunąć tego użytkownika?",
    "deleteErrorText": "Usuwanie użytkownika nie powiodło się. Spróbuj ponownie.",
    "deleteSuccessText": "Wybrany użytkownik został usunięty",
    "deleteSuccessTitle": "Usunięto użytkownika",
    "editUser": "Edycja użytkownika",
    "editUserErrorText": "Edycja użytkownika nie powiodła się. Spróbuj ponownie.",
    "editUserSuccessText": "Wybrany użytkownik został zmieniony",
    "editUserSuccessTitle": "Zmodyfikowano użytkownika",
    "inactive": "Nieaktywne",
    "isAccountActive": "Konto aktywne?",
    "loggedInAs": "Zalogowany jako",
    "noUsersMatchingPhrase": "Brak pracowników pasujących do podanej frazy",
    "noUsersToDisplay": "Brak użytkowników do wyświetlenia",
    "selectWorker": "Wybierz pracownika",
    "usersLabel": "Użytkownicy",
    "usersList": "Lista użytkowników",
    "usersSearchPlaceholder": "Podaj imię, nazwisko lub e-mail użytkownika"
  },
  "validation": {
    "fieldCanContainAtLeast1Char": "To pole musi zawierać co najmniej jeden znak",
    "fieldCanContainAtLeast24Chars": "To pole musi zawierać co najmniej {min} znaki",
    "fieldCanContainAtLeastNChars": "To pole musi zawierać co najmniej {min} znaków",
    "fieldCanContainAtMax1Char": "To pole może zawierać maksymalnie jeden znak",
    "fieldCanContainAtMax24Chars": "To pole może zawierać maksymalnie {max} znaki",
    "fieldCanContainAtMaxNChars": "To pole może zawierać maksymalnie {max} znaków",
    "onlyBigLetters": "To pole może zawierać wyłącznie duże litery",
    "onlyLettersAndDashes": "To pole może zawierać wyłącznie litery i myślniki",
    "onlyLettersAndNumbers": "To pole może zawierać wyłącznie litery i cyfry",
    "onlyNumbers": "To pole musi zawierać liczbę",
    "onlyIntegerNumbers": "To pole musi zawierać liczbę całkowitą",
    "passwordsAreNotIdentical": "Hasła nie są identyczne",
    "required": "To pole jest wymagane",
    "validDoubleNumericRequired": "Wymagana liczba w formacie 123.45",
    "validEmailRequired": "To pole musi zawierać poprawny adres e-mail",
    "validUrlRequired": "To pole musi zawierać poprawny adres URL",
    "valueCannotBeGreaterThan": "Wartość nie może być większa niż ",
    "valueCannotBeLessThan": "Wartość nie może być mniejsza niż ",
    "valueMustContainOrderID": "Nazwa zamówienia musi zawierać ID zamówienia: ",
    "youMustSelectValue": "Musisz wybrać wartość"
  },
  "welcome": {
    "baseballCaps": "Czapki z daszkiem",
    "capVizors": "Daszki",
    "choose": "Wybierz",
    "clear": "Wyczyść",
    "clientPanel": "Panel klienta",
    "companyName": "Headwear",
    "filter": "Filtruj",
    "filterAvailability": "Filtruj dostępności",
    "filterByNameOrCode": "Filtruj po nazwie/kodzie",
    "filterByPrice": "Filtruj po cenie",
    "hats": "Kapelusze",
    "noProductsInSearchCriteria": "Brak produktów spełniających podane kryteria",
    "orderInfo": "Realizuj zamówienia <span class=\"text-primary font-weight-bold\">w 5 prostych krokach</span>:",
    "productBrowserInfo": "Skorzystaj z naszej <span class=\"font-weight-bold\">wyszukiwarki produktów</span>. Znajdziesz w niej zdjęcia produktów, cenę oraz stan magazynowy. Z poziomu wyszukiwarki możesz też zacząć tworzyć zamówienie. Wystarczy kliknąć przy produkcie <span class=\"font-weight-bold\">\"Do koszyka\"</span>. Cały koszyk możesz potem dodać do swojego zamówienia.",
    "requireAll": "Wymagaj wszystkich",
    "searchProducts": "Szukaj produktu",
    "setp": "Krok",
    "stepFiveContent": "Kliknij przycisk <span class=\"font-weight-bold\">\"Zapisz ofertę\"</span> lub <span class=\"font-weight-bold\">\"Przekaż zamówienie do realizacji\"",
    "stepFourContent": "W zakładce <span class=\"font-weight-bold\">\"Dane ogólne\"</span> wypełnij dane dostawy oraz kontaktowe",
    "stepOneContent": "Przejdź do zakładki <span class=\"font-weight-bold\">\"Zamówienia\"</span>",
    "stepThreeContent": "W zakładce <span class=\"font-weight-bold\">\"Zamówienie\"</span> wybierz produkty oraz zdobienia",
    "stepTwoContent": "Kliknij przycisk <span class=\"font-weight-bold\">\"Dodaj\"</span>",
    "wantToCheckOurProducts": "Chcesz szybko sprawdzić nasze produkty i ceny?",
    "welcomeToClientPanel": "Witaj w panelu klienta HeadWear",
    "winterHats": "Czapki zimowe"
  }
};
